import React from "react";
import VatGenericSkeleton from "./VatGenericSkeleton";

function VatDetailSkeleton() {
  return (
    <>
      <VatGenericSkeleton />
    </>
  );
}

export default VatDetailSkeleton;
